import { dirhams } from '../format';

/**
 * Prices in words, as on the committee's screens and the desk (doc 39).
 * Plain logic: each app keeps its own GraphQL documents.
 */

export type BillingMethodType = 'PROGRESSIVE' | 'FIXED';
export type ConfigStatus = 'SCHEDULED' | 'CURRENT' | 'PAST';
type Tier = { tierStart: number; tierEnd: number | null; rate: string };
type Fee = {
  name: string;
  amount: string;
  feeType: 'FIXED' | 'PERCENTAGE';
  onlyWhenNoConsumption: boolean;
};

export const STATUS_LABELS: Record<ConfigStatus, string> = {
  SCHEDULED: 'مبرمجة',
  CURRENT: 'المعمول بها',
  PAST: 'سابقة',
};

/** A price tier in words: «من 1 إلى 30 م³: 4,00 درهم للمتر المكعب». */
export function describeTier(tier: Tier, method: BillingMethodType) {
  const price = `${dirhams(tier.rate)} للمتر المكعب`;
  if (method === 'FIXED') return price;
  const from = Math.max(tier.tierStart, 1);
  return tier.tierEnd === null
    ? `من ${from} م³ فما فوق: ${price}`
    : `من ${from} إلى ${tier.tierEnd} م³: ${price}`;
}

/** A fee in words, with when it applies (arqam's explicit flag). */
/** «الشرط: 18,00 درهم للفرد شهرياً». */
export const describeShart = (price: string) =>
  `الشرط: ${dirhams(price)} للفرد شهرياً`;

export function describeFee(fee: Fee) {
  const amount =
    fee.feeType === 'PERCENTAGE'
      ? `${Number(fee.amount)}% من ثمن الاستهلاك`
      : `${dirhams(fee.amount)} لكل فاتورة`;
  const when = fee.onlyWhenNoConsumption ? ' (عند استهلاك منعدم فقط)' : '';
  return `${fee.name}: ${amount}${when}`;
}
